<template>
  <v-app>
    <v-overlay
      :value="appIsLoading"
      :color="config.colors.background"
    ></v-overlay>

    <v-main v-if="fonts.length" :style="{background: config.colors.background}">
      <v-container class="pt-12">
        <v-card outlined>
          <v-sheet
            v-if="config.options.showHeader"
            class="v-sheet--offset d-flex align-center mx-auto pa-2 mb-n6"
            :color="headerBackground"
            elevation="3"
            outlined
            max-width="calc(100% - 32px)"
          >
            <v-img
              src="@/assets/logo.png"
              contain
              :max-width="$vuetify.breakpoint.mobile ? 80 : 100"
              class="mr-12"
              fill-height
            ></v-img>
            <span
              class="text-h4 font-weight-thin"
              :style="{color: config.colors.headerText}"
              >{{ headerText }}</span
            >
          </v-sheet>
          <v-card-text>
            <v-row>
              <v-col cols="12" lg="6" class="br-3">
                <v-card outlined>
                  <v-card-title>Dein Wunschtext</v-card-title>
                  <v-card-text>
                    <v-text-field
                      outlined
                      :color="config.colors.primary"
                      v-model="text"
                      required
                      hide-details
                      single-line
                      @input="setPreviewTextSize()"
                    ></v-text-field>
                  </v-card-text>
                </v-card>

                <v-card
                  :max-height="showAllFonts ? '' : '410'"
                  class="mt-6"
                  elevation="0"
                  outlined
                >
                  <v-card-title>Deine Schriftart</v-card-title>
                  <v-card-text>
                    <v-btn-toggle v-model="selectedFont" mandatory class="pl-3">
                      <v-row
                        :style="showAllFonts ? '' : 'height:300px;'"
                        style="overflow: auto; flex-grow: 1"
                      >
                        <v-col
                          v-for="font in fonts"
                          :key="font.name"
                          class="pa-0"
                          cols="12"
                        >
                          <v-btn
                            text
                            :color="config.colors.primary"
                            x-large
                            :class="font.name"
                            ><span class="text-truncate">{{
                                    font.name
                            }}</span></v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-btn-toggle>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" lg="6">
                <v-card
                  style="position: sticky; top: 0; height: 100%"
                  elevation="0"
                  outlined
                >
                  <v-card-title>Vorschau</v-card-title>
                  <div class="d-flex pa-2">
                    <v-card-text
                      class="
                            d-flex
                            black--text
                            fill-height
                            align-center
                            justify-center
                            text-no-wrap
                          "
                      :class="fonts[selectedFont].name"
                      :style="
                              `font-size:${previewTextSize}em; min-height:200px`
                            "
                      ref="box"
                      v-resize="setPreviewTextSize"
                      style="overflow: hidden"
                    >
                      <span ref="text">{{ text }}</span>
                    </v-card-text>
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  data: () => ({
    appIsLoading: false,
    text: null,
    headerText: null,
    selectedFont: 0,
    fonts: [],
    showAllFonts: false,
    previewTextSize: 3,
    config: {
      options: {
        showHeader: true,
      },
      colors: {
        background: "#333333",
        primary: "#cc0000",
        headerBackground: "#ffffcc",
        headerText: "0000ff",
      },
      text: {
        headerText: "Header",
        defaultText: "Default Text",
      },
    },
  }),
  methods: {
    getFonts() {
      axios
        .get("/fonts/fonts.txt")
        .then((response) => {
          let fonts = [];
          response.data
            .replace(/ /g, "")
            .split("\n")
            .forEach((element) => {
              let font = element.replace(/\s/g, "");
              let name = font.split(".")[0];
              let url = "/fonts/" + font;
              if (name != "") {
                fonts.push({
                  name: name,
                  url: url,
                });
                document.head.innerHTML += `
              <style>
               @font-face {
                  font-family: "${name}";
                  src: url("${url}");
                }

                .${name} {
                  font-family: "${name}" !important;
                }
              </style>`;
              }
            });
          this.fonts = fonts;
        })
        .finally(() => {
          this.$nextTick(() => {
            this.setPreviewTextSize();
          })
        });
    },
    getConfig() {
      axios
        .get("/config.json")
        .then((response) => {
          this.config = Object.assign({}, response.data);
        })
        .finally(() => {
          this.text = this.config.text.defaultText;
          this.headerText = this.config.text.headerText;
          this.appIsLoading = false;
        });
    },
    setPreviewTextSize() {
      let text = this.$refs.text;
      if (text) {
        let textWidth = text.offsetWidth;
        let boxWidth = this.$refs.box.offsetWidth;
        let scale = 3;
        if ((boxWidth - 60) / textWidth < 3) {
          scale = (boxWidth - 60) / textWidth;
        }
        text.style.transform = "scale(" + scale + ")";
      }
    },
  },
  computed: {
    headerTextColor() {
      return this.config.colors.headerText;
    },
    headerBackground() {
      return this.config.colors.headerBackground;
    },
  },
  watch: {
    selectedFont: function() {
      this.$nextTick(function() {
        this.setPreviewTextSize();
      });
    },
  },
  mounted() {
    this.getFonts();
  },
  created() {
    this.getConfig();
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #cccccc;
}
.border-left {
  border-left: 1px solid #cccccc;
}

.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
